<template>
  <div class="report-filter report-status">
    <div class="ms-help">
      Статус проекта:
    </div>
    <i-select v-model="status" style="width: 180px;" multiple placeholder="Все">
      <i-option
        v-for="item in statuses"
        :value="item.id"
        :key="item.id"
      >
        {{ item.name }}
      </i-option>
    </i-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      statuses: [
        // { id: 'all', name: 'Все' },
        ...this.$store.state.contractStatuses
      ]
    }
  },
  computed: {
    status: {
      get () {
        return this.$store.state.reports.status
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'status',
          value
        })
      }
    }
  },
  created () {
    this.status = [this.$store.state.contractStatuses[0].id]
  }
}
</script>

<style lang="less">
.report-status {
  display: flex;
  align-items: center;

  .ms-help {
    margin-right: 8px;
  }
}
</style>
